exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wz-login-wrapper{height:100%}.wz-login-card{min-width:500px;min-height:400px}.content{position:absolute;left:50%;top:25%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.txt-invalid-login{color:red;-ms-flex-item-align:center;align-self:center}", ""]);

// exports
